import { useCallback, useState } from 'react';

type Speech = {
  supported: boolean;
  listening: boolean;
  start: () => void;
  stop: () => void;
  clearError: () => void;
};

/** Microphone and typing toggles for the dock: only one input mode at a time. */
export function useRecordingControls(speech: Speech) {
  const [typing, setTyping] = useState(false);

  const toggleMic = useCallback(() => {
    // No speech recognition in this browser (Firefox, Brave…): open the text
    // field, where the phone keyboard's own microphone can dictate.
    if (!speech.supported) {
      setTyping(true);
      return;
    }
    if (speech.listening) {
      speech.stop();
      return;
    }
    setTyping(false);
    speech.clearError();
    speech.start();
  }, [speech]);

  const toggleTyping = useCallback(() => {
    if (speech.listening) speech.stop();
    setTyping((on) => !on);
  }, [speech]);

  /** Stop any recording (used when switching to a read-only view). */
  const stopAll = useCallback(() => {
    if (speech.listening) speech.stop();
    setTyping(false);
  }, [speech]);

  return { typing, setTyping, toggleMic, toggleTyping, stopAll };
}
